import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { Client, CreateClientPayload } from "#/types/client";

export const clientsApi = {
  create: (body: CreateClientPayload): Promise<ApiResponse<Client>> =>
    api.post("/client", body),
  update: (
    id: number,
    body: Partial<CreateClientPayload>
  ): Promise<ApiResponse<Client>> => api.patch(`/client/${id}`, body),
  getAll: (
    params: BaseFilterParams
  ): Promise<ApiResponse<Paginated<Client[]>>> =>
    api.get("/client", { params }),
  getById: (id: number): Promise<ApiResponse<Client>> =>
    api.get(`/client/${id}`),
  getBySlug: (slug: string): Promise<ApiResponse<Client>> =>
    api.get(`/client/slug/${slug}`),
};
